import { useQuery } from '@tanstack/react-query';

import { api } from '@/lib/axios';
import { API_ROUTES } from '@/constants';

import type { FormQRResponse } from '@/types/form';

const SHARE_KEYS = {
    all: ['form-share'] as const,
    qr: (slug: string) => [...SHARE_KEYS.all, 'qr', slug] as const,
};

export { SHARE_KEYS as FORM_SHARE_KEYS };

export function useFormQR(slug: string) {
    return useQuery({
        queryKey: SHARE_KEYS.qr(slug),
        queryFn: async () => {
            const { data } = await api.get<FormQRResponse>(API_ROUTES.formQR(slug));
            return data;
        },
        enabled: !!slug,
    });
}

export function buildPrefillUrl(
    formBaseUrl: string,
    prefills: Record<string, string>
): string {
    const params = new URLSearchParams();
    Object.entries(prefills).forEach(([key, value]) => {
        if (value) params.set(key, value);
    });
    const qs = params.toString();
    return qs ? `${formBaseUrl}?${qs}` : formBaseUrl;
}
